export const TABS = { SEARCH: "SEARCH", GENERATE: "GENERATE", EDITION: "EDITION" };
export const SEARCH_TABS = { DELIVERABLE: "DELIVERABLE", PROJECT: "PROJECT" };
export const SUMMARY_TABS = { VISUALIZATION: "VISUALIZATION", SOURCES: "SOURCES" };
